import type { PlanUnitMix } from 'components/types';
import { getPlanUnitIds } from 'components/utils';
import { useState } from 'react';

export const usePlanUnitSelection = () => {
  'use memo';

  const [selectedPlanUnits, setSelectedPlanUnits] = useState<PlanUnitMix[]>([]);

  const organizationalUnitIds = Array.from(
    new Set(getPlanUnitIds(selectedPlanUnits))
  ).join(',');

  return {
    selectedPlanUnits,
    setSelectedPlanUnits,
    organizationalUnitIds
  };
};
